<!-- START Sidebar (left)-->
@if (menuItems) {
<div class="aside-inner">
  <nav
    class="sidebar"
    [class.show-scrollbar]="settings.getLayoutSetting('asideScrollbar')"
  >
    <!-- START sidebar nav-->
    <ul class="sidebar-nav">
      @for (item of menuItems; track item) {
      <li
        [ngClass]="{ 'nav-heading': item.heading }"
        [routerLinkActive]="['active']"
      >
        <!-- menu heading -->
        @if (item.heading) {
        <span>{{ (item.translate | translate) || item.text }}</span>
        }
        <!-- external links -->
        @if (!item.heading && !item.submenu && item.elink) {
        <a
          href
          [attr.target]="item.target"
          [attr.href]="item.elink"
          title="{{ item.text }}"
        >
          @if (item.alert) {
          <span
            class="float-right"
            [ngClass]="item.label || 'badge badge-success'"
            >{{ item.alert }}</span
          >
          } @if (item.fa) {
          <em [ngClass]="item.fa"></em>
          } @if (item.icon) {
          <em [ngClass]="item.icon"></em>
          }
          <span>{{ (item.translate | translate) || item.text }}</span>
        </a>
        }
        <!-- single menu item -->
        @if (!item.heading && !item.submenu && !item.elink) {
        <a
          href
          [routerLink]="item.link"
          [attr.route]="item.link"
          title="{{ item.text }}"
          (mouseenter)="toggleSubmenuHover($event)"
        >
          @if (item.alert) {
          <span
            class="float-right"
            [ngClass]="item.label || 'badge badge-success'"
            >{{ item.alert }}</span
          >
          } @if (item.fa) {
          <em [ngClass]="item.fa"></em>
          } @if (item.icon) {
          <em [ngClass]="item.icon"></em>
          }
          <span>{{ (item.translate | translate) || item.text }}</span>
        </a>
        }
        <!-- has submenu -->
        @if (!item.heading && item.submenu) {
        <a
          href
          title="{{ item.text }}"
          (mouseenter)="toggleSubmenuHover($event)"
        >
          @if (item.alert) {
          <span
            class="float-right"
            [ngClass]="item.label || 'badge badge-success'"
            >{{ item.alert }}</span
          >
          } @if (item.fa) {
          <em [ngClass]="item.fa"></em>
          } @if (item.icon) {
          <em [ngClass]="item.icon"></em>
          }
          <span>{{ (item.translate | translate) || item.text }}</span>
        </a>
        }
      </li>
      }
      <!-- START user info-->
      <li class="has-user-block">
        <div class="item user-block">
          <!-- User picture-->
          <div class="user-block-picture">
            <div class="user-block-status">
              @if (config?.imgFilename) {
              <img [src]="'assets/img/' + config?.imgFilename" width="100%" />
              }
            </div>
          </div>
        </div>
      </li>
      <!-- END user info-->
    </ul>
    <!-- END sidebar nav-->
  </nav>
</div>
}
<!-- END Sidebar (left)-->
